import { takeLatest, put, call } from "redux-saga/effects";
import reportAction from "../actions/reportAction";
import HttpService from "../../services/httpServices/httpServices";
import helperSpinner from "../../helpers/spinner";

const getHeaderForRequest = () => {
  const token = localStorage.getItem("token");
  const headersRequest = {
    headers: {
      authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  return headersRequest;
};

const getReportWebSitePublisherWorker = function* (action) {
  const sitePublisherID = action.payload.site_publisher_ID;
  const dateFrom = action.payload.date_from.replace(" ", "_");
  const dateTo = action.payload.date_to.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/site-publisher/" +
        sitePublisherID +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = result.data.data;

    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getReportAllWebSitePublisherWorker = function* (action) {
  const dateFrom = action.payload.dateFrom.replace(" ", "_");
  const dateTo = action.payload.dateTo.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/all-site-publisher" +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = result.data.data;

    yield put({
      type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getReportAllWebSitePublisherDataChart = function* (action) {
  const dateFrom = action.payload.dateFrom.replace(" ", "_");
  const dateTo = action.payload.dateTo.replace(" ", "_");
  const eventReport = action.payload.eventReport;
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/data-chart/all-site-publisher" +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo +
        "&event=" +
        eventReport;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = {
      dataChart: result.data.data,
      dateFrom,
      dateTo,
    };

    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getReportWebSitePublisherDataChart = function* (action) {
  const dateFrom = action.payload.dateFrom.replace(" ", "_");
  const dateTo = action.payload.dateTo.replace(" ", "_");
  const eventReport = action.payload.eventReport;
  const sitePublisherID = action.payload.sitePublisherID;
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/data-chart/site-publisher/" +
        sitePublisherID +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo +
        "&event=" +
        eventReport;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = {
      dataChart: result.data.data,
      dateFrom,
      dateTo,
    };

    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getReportWebSitePublisherSeparationDataChartWorker = function* (action) {
  const dateFrom = action.payload.dateFrom.replace(" ", "_");
  const dateTo = action.payload.dateTo.replace(" ", "_");
  const separation = action.payload.separation;
  const sitePublisherID = action.payload.sitePublisherID;
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/data-separation/site-publisher/" +
        sitePublisherID +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo +
        "&separation=" +
        separation;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = result.data.data;

    yield put({
      type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

const getReportAllWebSitePublisherSeparationDataChartWorker = function* (
  action
) {
  const dateFrom = action.payload.dateFrom.replace(" ", "_");
  const dateTo = action.payload.dateTo.replace(" ", "_");
  helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  try {
    const result = yield call(() => {
      const url =
        process.env.REACT_APP_DOMAIN_API +
        "/v1/publisher/report/data-separation/all-site-publisher" +
        "?date_from=" +
        dateFrom +
        "&date_to=" +
        dateTo;
      const headersRequest = getHeaderForRequest();
      return HttpService.getRequest(url, headersRequest);
    });
    let payloadData = result.data.data;

    yield put({
      type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_SUCCESS,
      payload: payloadData,
    });
  } catch (error) {
    yield put({
      type: reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED,
      payload: null,
    });
  }
  helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
};

export const getReportWatcher = function* () {
  yield takeLatest(
    reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER,
    getReportAllWebSitePublisherWorker
  );
  yield takeLatest(
    reportAction.GET_REPORT_WEB_SITE_PUBLISHER,
    getReportWebSitePublisherWorker
  );
  yield takeLatest(
    reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART,
    getReportAllWebSitePublisherDataChart
  );
  yield takeLatest(
    reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART,
    getReportWebSitePublisherDataChart
  );
  yield takeLatest(
    reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART,
    getReportWebSitePublisherSeparationDataChartWorker
  );
  yield takeLatest(
    reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART,
    getReportAllWebSitePublisherSeparationDataChartWorker
  );
};
